enum ExpenseCategoryType {
  OUTPAVE = "OUTPAVE",
  ACCOUNT = "ACCOUNT",
}

export default ExpenseCategoryType;
